import { Box, Button, Group, Input, InputBase, Title } from "@mantine/core";
import { useState } from "react";
import { usePostAddProjectTdRoomsMutation } from "./openapi";

const AddTrainingData: React.FC = () => {
  const [projectNo, setProjectNo] = useState<number>(10216575);

  const [addTdRooms, isLoading] = usePostAddProjectTdRoomsMutation();

  return (
    <Group p={5}>
      <Input
        placeholder="Angi prosjektnr"
        type="number"
        value={projectNo}
        onChange={(e) => setProjectNo(Number(e.target.value))}
      />

      <Button
        onClick={() =>
          addTdRooms({
            body: {
              projectNo,
            },
          })
        }
      >
        Start
      </Button>
    </Group>
  );
};

export default AddTrainingData;
